import React from 'react';
import { Pane } from 'evergreen-ui';

/**
 * A custom Progress component since Evergreen UI doesn't have one
 *
 * @param {Object} props - Component props
 * @param {number} props.value - Current progress value (0-1)
 * @param {string} props.width - Width of the progress bar
 * @param {number} props.marginY - Vertical margin
 * @param {Object} props.containerProps - Additional props for the container Pane
 */
const Progress = ({ value, width = '100%', marginY = 0, ...props }) => {
  // If value is null, show indeterminate progress
  const isIndeterminate = value === null;

  // Convert value to percentage (0-100)
  const percentage = isIndeterminate ? 0 : Math.min(Math.max(value, 0), 1) * 100;

  return (
    <Pane
      height={8}
      width={width}
      marginY={marginY}
      borderRadius={4}
      backgroundColor="#E4E7EB"
      position="relative"
      overflow="hidden"
      {...props}
    >
      <Pane
        position="absolute"
        top={0}
        left={0}
        height="100%"
        width={`${percentage}%`}
        borderRadius={4}
        backgroundColor="#47B881"
        transition="width 0.3s ease-in-out"
      />

      {isIndeterminate && (
        <Pane
          position="absolute"
          top={0}
          left={0}
          height="100%"
          width="30%"
          borderRadius={4}
          backgroundColor="#47B881"
          animation="indeterminate-progress 1.5s infinite linear"
          css={{
            '@keyframes indeterminate-progress': {
              '0%': { left: '-30%' },
              '100%': { left: '100%' }
            }
          }}
        />
      )}
    </Pane>
  );
};

export default Progress;
